import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import HomeScreen from './Screens/HomeScreen';
import Footer from './Screens/Footer';
import Features from './Screens/Features';
import Download from './Screens/Download';
import Contact from './Screens/Contact';
import PrivacyPolicy from './Screens/PrivacyPolicy';
import TermsOfService from './Screens/TermsOfService';
import FAQ from './Screens/FAQ';
import SafetyTips from './Screens/SafetyTips';

function App () {

  const router = createBrowserRouter([
    {
      path: '/',
      element: <HomeScreen />
    },
    {
      path: '/features',
      element: <Features />
    },
    {
      path: '/download',
      element: <Download />
    },
    {
      path: '/contact',
      element: <Contact />
    },
    {
      path: '/privacy-policy',
      element: <PrivacyPolicy />
    },
    {
      path: '/terms-of-service',
      element: <TermsOfService />
    },
    {
      path: '/faq',
      element: <FAQ />
    },
    {
      path: '/safety-tips',
      element: <SafetyTips />
    },
  ]);

  return (
    <div className="app-wrapper">
        <RouterProvider router={router} />
        <Footer />
    </div>
  );
}

export default App;
